import {
    COMMUNITY_PARTICIPANT_LIST_REQUEST,
    COMMUNITY_PARTICIPANT_LIST_SEARCH_REQUEST,
    COMMUNITY_MEMBERS_LIST_REQUEST,
    COMMUNITY_MEMBERS_ADD_LIST_SEARCH_REQUEST,
    COMMUNITY_MANAGERS_LIST_REQUEST,
    COMMUNITY_FOLLOWERS_LIST_REQUEST,
    COMMUNITY_INVITED_LIST_REQUEST,
    COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST
} from "../actions/action-types"
import {
    communityParticipantListRequest,
    communityMembersListRequest,
    communityMembersListCachedResponse,
    communityMembersListResponse,
    communityMembersListErrorResponse,
    communityManagersListRequest,
    communityManagersListCachedResponse,
    communityManagersListResponse,
    communityManagersListErrorResponse,
    communityFollowersListRequest,
    communityFollowersListCachedResponse,
    communityFollowersListResponse,
    communityFollowersListErrorResponse,
    communityInvitedListRequest,
    communityInvitedListCachedResponse,
    communityInvitedListResponse,
    communityInvitedListErrorResponse,
    communityAwaitingApprovalListRequest,
    communityAwaitingApprovalListCachedResponse,
    communityAwaitingApprovalListResponse,
    communityAwaitingApprovalListErrorResponse
} from "../actions/community-participant-actions"
import { userListRequest } from "../actions/user-actions"
import {
    getCommunityMemberList,
    getCommunityManagerList,
    getCommunityFollowerList,
    getCommunityInvitedList,
    getCommunityAwaitingApprovalList
} from "../api/community-participant-api"
import { requestListEpic } from "./default-epics/default-entity-epics"

export const requestCommunityParticipantListEpic = (action$, { getState }) =>
    action$
        .ofType(COMMUNITY_PARTICIPANT_LIST_REQUEST)
        .map(({ participantType, pagingRequest }) => {
            switch (participantType) {
                case "managers":
                    return communityManagersListRequest(pagingRequest)
                case "followers":
                    return communityFollowersListRequest(pagingRequest)
                case "invited":
                    return communityInvitedListRequest(pagingRequest)
                case "awaitingApproval":
                    return communityAwaitingApprovalListRequest(pagingRequest)
                case "members":
                default:
                    return communityMembersListRequest(pagingRequest)
            }
        })

export const requestCommunityMembersAddListSearchEpic = (
    action$,
    { getState }
) =>
    action$
        .ofType(COMMUNITY_MEMBERS_ADD_LIST_SEARCH_REQUEST)
        .debounceTime(500)
        .map(({ searchCriteria }) => {
            const { presentation, paging } = getState()
            const serialisedSearchCriteria =
                presentation.communities.membersAddSearchCriteria
            let pagingRequest = paging.users[serialisedSearchCriteria] || {}
            pagingRequest = {
                ...pagingRequest,
                searchCriteria
            }

            return userListRequest(pagingRequest)
        })

export const requestCommunityParticipantListSearchEpic = (
    action$,
    { getState }
) =>
    action$
        .ofType(COMMUNITY_PARTICIPANT_LIST_SEARCH_REQUEST)
        .debounceTime(500)
        .map(({ searchCriteria }) => {
            const { presentation, paging } = getState()
            const participantType =
                presentation.communities.selectedParticipantType
            const serialisedSearchCriteria =
                presentation.communities[`${participantType}SearchCriteria`]
            let pageRequest =
                paging.communityParticipants[participantType][
                    serialisedSearchCriteria
                ] || {}
            pageRequest = {
                ...pageRequest,
                searchCriteria
            }
            return communityParticipantListRequest(participantType, pageRequest)
        })

export const requestCommunityMembersListEpic = requestListEpic(
    COMMUNITY_MEMBERS_LIST_REQUEST,
    getCommunityMemberList,
    ["communityParticipants", "members"],
    communityMembersListResponse,
    communityMembersListCachedResponse,
    communityMembersListErrorResponse
)

export const requestCommunityManagersListEpic = requestListEpic(
    COMMUNITY_MANAGERS_LIST_REQUEST,
    getCommunityManagerList,
    ["communityParticipants", "managers"],
    communityManagersListResponse,
    communityManagersListCachedResponse,
    communityManagersListErrorResponse
)

export const requestCommunityFollowersListEpic = requestListEpic(
    COMMUNITY_FOLLOWERS_LIST_REQUEST,
    getCommunityFollowerList,
    ["communityParticipants", "followers"],
    communityFollowersListResponse,
    communityFollowersListCachedResponse,
    communityFollowersListErrorResponse
)

export const requestCommunityInvitedListEpic = requestListEpic(
    COMMUNITY_INVITED_LIST_REQUEST,
    getCommunityInvitedList,
    ["communityParticipants", "invited"],
    communityInvitedListResponse,
    communityInvitedListCachedResponse,
    communityInvitedListErrorResponse
)

export const requestCommunityAwaitingApprovalListEpic = requestListEpic(
    COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST,
    getCommunityAwaitingApprovalList,
    ["communityParticipants", "awaitingApproval"],
    communityAwaitingApprovalListResponse,
    communityAwaitingApprovalListCachedResponse,
    communityAwaitingApprovalListErrorResponse
)
